module.exports = __webpack_public_path__ + "img/数据指标select.f7ad97a8.svg";